import { useOutletContext } from "react-router-dom";

import { Button, Stack } from "@mui/material";
import { ContentCard, FormikErrorNotification } from "@shared";

import { VolunteerResponse } from "@/api";
import { VolunteerFormFields } from "@/pages/system-settings/volunteers/components/VolunteerFormFields";
import { useTranslation } from "@/translations";

import { useVolunteerPersonalData } from "./hooks/useVolunteerPersonalData";

export function VolunteerPersonalData() {
  const { t } = useTranslation();
  const volunteer = useOutletContext<VolunteerResponse>();
  const { formik, dropdownOptions, handleDelete, isDeleting } = useVolunteerPersonalData(volunteer);

  return (
    // A real form element so Enter in any field submits. noValidate leaves validation to the schema.
    // FormikErrorNotification surfaces a rejected submit as a toast — the form validates on submit
    // only, so without it the sole feedback is helper text that may be scrolled out of view.
    <Stack component="form" noValidate onSubmit={formik.handleSubmit} sx={{ flex: 1, gap: 1 }}>
      <FormikErrorNotification formik={formik} />

      <ContentCard title={t("volunteers.tabs.personalData")}>
        <VolunteerFormFields formik={formik} dropdownOptions={dropdownOptions} />
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Button
            type="button"
            variant="outlined"
            color="error"
            onClick={handleDelete}
            disabled={isDeleting || formik.isSubmitting}
          >
            {t("common.delete")}
          </Button>
          <Stack direction="row" gap={2}>
            <Button
              type="button"
              variant="outlined"
              onClick={formik.handleReset}
              disabled={!formik.dirty || formik.isSubmitting}
            >
              {t("common.resetChanges")}
            </Button>
            <Button type="submit" variant="contained" disabled={!formik.dirty || formik.isSubmitting}>
              {t("common.save")}
            </Button>
          </Stack>
        </Stack>
      </ContentCard>
    </Stack>
  );
}
